(function () {
  /**
   * FLORENTIA – main.js
   * Allgemeine JavaScript-Interaktionen.
   * Seitenspezifische Logik kommt in separate Dateien.
   */

  // ── Pflanzenfoto auf Produktkarten (snippets/produkt-karte.liquid) ──
  // Erst einblenden, wenn es ganz geladen ist (data-geladen, CSS in main.css):
  // sonst zeigt der Browser bei langsamem Netz ein halbes Foto (gemessen
  // 2026-10-15). load blubbert nicht -> auf document in der Capture-Phase
  // lauschen (gilt auch für Duftfinder-Karten, die erst später laden);
  // schon fertige Bilder beim Start markieren (main.js ist defer).
  const fotoMarkieren = img => {
    if (img.matches('img[data-bild="pflanzenfoto"]') && img.naturalWidth > 0) img.setAttribute('data-geladen', '');
  };
  document.addEventListener('load', e => { if (e.target instanceof HTMLImageElement) fotoMarkieren(e.target); }, true);
  document.querySelectorAll('img[data-bild="pflanzenfoto"]').forEach(img => { if (img.complete) fotoMarkieren(img); });

  document.addEventListener('DOMContentLoaded', () => {

    // ── Scroll-triggered Fade-Up ──
    const fadeEls = document.querySelectorAll('.fade-up');
    if (fadeEls.length) {
      const fadeObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            fadeObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05 });
      fadeEls.forEach(el => fadeObserver.observe(el));
    }

    // ── Nach dem Absenden (Newsletter, Kontakt) ──
    // Shopify leitet auf …#contact_form zurück, der Browser springt zum
    // Formular, Überschrift und Eyebrow verschwinden unter dem fixen Kopf.
    // Stattdessen die ganze Section mittig unter dem Kopf zeigen, auch wenn
    // darüber noch Inhalt nachlädt («Passt dazu»), bis der Kunde selbst
    // scrollt (Marc 2026-10-19).
    const formularMeldung = document.querySelector('[data-formular-meldung]');
    if (formularMeldung) {
      const sektion = formularMeldung.closest('section');
      const kopf = document.getElementById('site-header');
      const zeigen = () => {
        const rand = sektion.getBoundingClientRect();
        const kopfHoehe = kopf ? kopf.offsetHeight : 0;
        const frei = window.innerHeight - kopfHoehe;
        const ziel = window.scrollY + rand.top - kopfHoehe - Math.max(0, (frei - rand.height) / 2);
        window.scrollTo({ top: ziel, behavior: 'instant' });
      };
      if (location.hash) history.replaceState(null, '', location.pathname + location.search);
      window.addEventListener('load', () => {
        const beobachter = new ResizeObserver(zeigen);
        beobachter.observe(document.body);
        const stopp = () => beobachter.disconnect();
        setTimeout(stopp, 2500);
        ['wheel', 'touchstart', 'keydown'].forEach(typ => window.addEventListener(typ, stopp, { once: true, passive: true }));
      });
    }

    // ── Accordion ──
    document.querySelectorAll('.accordion__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.accordion__item');
        const isOpen = item.classList.contains('is-open');

        // Alle im selben Accordion schliessen
        const accordion = item.closest('.accordion');
        if (accordion) {
          accordion.querySelectorAll('.accordion__item.is-open').forEach(openItem => {
            openItem.classList.remove('is-open');
            openItem.querySelector('.accordion__btn').setAttribute('aria-expanded', 'false');
          });
        }

        // Angeklicktes öffnen, wenn es vorher geschlossen war
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      // Keyboard: Escape schliesst offenes Item, Home/End springt an Rand (WAI-ARIA APG)
      btn.addEventListener('keydown', (e) => {
        const accordion = btn.closest('.accordion');
        if (!accordion) return;

        if (e.key === 'Escape') {
          const item = btn.closest('.accordion__item');
          if (item.classList.contains('is-open')) {
            item.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          }
        } else if (e.key === 'Home' || e.key === 'End') {
          e.preventDefault();
          const btns = accordion.querySelectorAll('.accordion__btn');
          btns[e.key === 'Home' ? 0 : btns.length - 1].focus();
        }
      });
    });

    // ── Mengenauswahl ──
    // Kein aria-live am Display: die Buttons tragen den aktuellen Stand selbst im aria-label,
    // so meldet der Screenreader den Wert direkt beim Auslösen (keine Doppelmeldung).
    const qtyDisplay = document.getElementById('product-qty');
    if (qtyDisplay) {
      let count = 1;
      const qtyBtns = document.querySelectorAll('.qty-btn');
      function updateQtyLabels() {
        qtyBtns.forEach(btn => {
          const dir = Number(btn.dataset.qty) < 0 ? 'verringern' : 'erhöhen';
          btn.setAttribute('aria-label', 'Menge ' + dir + ', aktuell ' + count);
        });
      }
      const qtyInput = document.getElementById('product-qty-input');
      qtyBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          count = Math.max(1, count + Number(btn.dataset.qty));
          qtyDisplay.textContent = count;
          if (qtyInput) qtyInput.value = count;
          updateQtyLabels();
        });
      });
    }

    // ── Shop-Filter (Collection / Suche) ──
    // Sidebar (Desktop) ↔ Off-Canvas-Drawer (Mobile, <900px). Mehrfachauswahl
    // pro Gruppe: OR innerhalb einer Gruppe, AND zwischen den Gruppen. GRUPPEN
    // ordnet jeder Gruppe ihr kommagetrenntes data-Attribut der Karte zu.
    const filterPanel = document.querySelector('[data-filter-panel]');
    if (filterPanel) {
      const GRUPPEN = { note: 'note', character: 'categories', groesse: 'size', bereich: 'bereich', art: 'art' };
      const state = Object.fromEntries(Object.keys(GRUPPEN).map(g => [g, new Set()]));
      const werteVon = (card, g) => (card.dataset[GRUPPEN[g]] || '').split(',');
      const allCards   = Array.from(document.querySelectorAll('.product-card[data-categories]'));
      const promoCards = Array.from(document.querySelectorAll('.promo-card'));
      const countEl    = document.querySelector('[data-result-count]');
      const badgeEls   = Array.from(document.querySelectorAll('[data-badge]'));

      // Grösse-Filter dynamisch aus den vorhandenen Karten-Grössen (data-size) bauen,
      // bevor `checks` abgefragt wird — so erscheinen nur tatsächlich vorhandene Grössen.
      // data-handle = Beschriftung als Kurzform ("500 ml" -> "500-ml"), damit die
      // Menü-Pille «500 ml» (?filter=500-ml) die Grösse anhakt.
      const sizeList = filterPanel.querySelector('[data-size-options]');
      if (sizeList) {
        const seen = new Set();
        allCards.forEach(c => (c.dataset.size || '').split(',').forEach(s => { if (s) seen.add(s); }));
        const sortedSizes = Array.from(seen).sort((a, b) => parseFloat(a) - parseFloat(b));
        if (sortedSizes.length) {
          sizeList.innerHTML = sortedSizes.map(key => {
            // "5ml" -> "5 ml", "28beutel" -> "28 Beutel" (Substantiv gross, Einheiten klein)
            const label = key.replace(/^([\d.,]+)\s*([a-z]+)$/i, (m, zahl, einheit) =>
              `${zahl} ${einheit === 'beutel' ? 'Beutel' : einheit}`);
            const handle = label.toLowerCase()
              .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
              .replace(/[^a-z0-9]+/g, '-');
            return `<li><button type="button" class="fd-check" data-group="groesse" data-value="${key}" data-handle="${handle}"><span class="fd-check__box"></span>${label}</button></li>`;
          }).join('');
          sizeList.closest('[data-size-group]').hidden = false;
        }
      }

      // Praxis-Bereich und Art ebenso aus den Karten bauen: Wert und data-handle
      // = Kurzform (data-bereich/data-art), Beschriftung = Originalname aus
      // data-*-namen ('|'-getrennt, gleiche Reihenfolge), alphabetisch.
      // data-nur-wenn-alle: Gruppe nur, wenn jede Karte einen Wert trägt.
      filterPanel.querySelectorAll('[data-dyn-group]').forEach(wrap => {
        const g = wrap.dataset.dynGroup;
        if (wrap.hasAttribute('data-nur-wenn-alle') && allCards.some(c => !c.dataset[g])) return;
        const namen = new Map();
        allCards.forEach(c => {
          const n = (c.dataset[g + 'Namen'] || '').split('|');
          werteVon(c, g).forEach((v, i) => { if (v && !namen.has(v)) namen.set(v, n[i] || v); });
        });
        if (!namen.size) return;
        const list = wrap.querySelector('[data-dyn-options]');
        [...namen].sort((a, b) => a[1].localeCompare(b[1], 'de')).forEach(([v, name]) => {
          const li = document.createElement('li');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'fd-check';
          btn.dataset.group = g;
          btn.dataset.value = v;
          btn.dataset.handle = v;
          btn.innerHTML = '<span class="fd-check__box"></span>';
          btn.append(name);
          li.append(btn);
          list.append(li);
        });
        wrap.hidden = false;
      });

      // Wo der Praxis-Bereich erscheint (Praxisbedarf), ist er die einzige
      // «Kategorie»: Art und Grösse wiederholen dort nur fremde Collections bzw.
      // «500 ml». Knöpfe entfernen, damit `checks` und Vorauswahl sie nicht sehen.
      const bereichWrap = filterPanel.querySelector('[data-dyn-group="bereich"]');
      if (bereichWrap && !bereichWrap.hidden) {
        filterPanel.querySelectorAll('[data-dyn-group="art"], [data-size-group]').forEach(wrap => {
          wrap.hidden = true;
          wrap.querySelector('ul').replaceChildren();
        });
      }

      // Duftnote/Duftcharakter (statisch gerenderte Buttons) nur zeigen, wenn
      // Karten die Werte tragen; Buttons ohne Treffer ausblenden — gleiches
      // Prinzip wie die Grösse. Auf Collections ohne diese Metafelder (fette
      // Öle, Hydrolate) verschwinden die Gruppen so von selbst.
      [{ group: 'note', key: 'note' }, { group: 'character', key: 'categories' }].forEach(({ group, key }) => {
        const present = new Set();
        allCards.forEach(c => (c.dataset[key] || '').split(',').forEach(v => { if (v) present.add(v); }));
        let any = false;
        filterPanel.querySelectorAll(`.fd-check[data-group="${group}"]`).forEach(btn => {
          const hit = present.has(btn.dataset.value);
          btn.closest('li').hidden = !hit;
          if (hit) any = true;
        });
        const wrap = filterPanel.querySelector(`[data-filter-group="${group}"]`);
        if (wrap) wrap.hidden = !any;
      });

      const checks     = Array.from(document.querySelectorAll('.fd-check[data-group]'));

      function applyFilters() {
        let visible = 0;
        // Grössere Geschwister (data-groesse-zusatz, Fette Öle / Hydrolate)
        // erscheinen nur mit Grössen-Filter, dann an Stelle der kleinen Karte.
        allCards.forEach(card => {
          const show = (state.groesse.size > 0 || !card.hasAttribute('data-groesse-zusatz')) &&
            Object.keys(GRUPPEN).every(g =>
              state[g].size === 0 || werteVon(card, g).some(v => state[g].has(v)));
          card.style.display = show ? '' : 'none';
          if (show) visible++;
        });
        if (countEl) countEl.textContent = visible;

        // Promo-Karten ausblenden, sobald gefiltert wird — sie sprengen das Grid (span 2)
        const total = Object.values(state).reduce((n, s) => n + s.size, 0);
        promoCards.forEach(p => { p.style.display = total > 0 ? 'none' : ''; });

        // Checkbox-Zustände + Badge (Anzahl aktiver Filter) synchronisieren
        checks.forEach(c => {
          const active = state[c.dataset.group] && state[c.dataset.group].has(c.dataset.value);
          c.classList.toggle('is-active', !!active);
          c.setAttribute('aria-pressed', String(!!active));
        });
        badgeEls.forEach(b => {
          b.textContent = total > 0 ? String(total) : '';
          b.classList.toggle('is-empty', total === 0);
        });

        // Aktive Filter als ?filter=<handle> (mehrfach) in die Adresse, ohne Neuladen:
        // Sortieren (lädt neu), Zurück-Knopf und geteilte Links behalten sie so.
        const params = new URLSearchParams(location.search);
        params.delete('filter');
        new Set(checks.filter(c => c.classList.contains('is-active')).map(c => c.dataset.handle))
          .forEach(h => params.append('filter', h));
        const query = params.toString();
        history.replaceState(history.state, '', location.pathname + (query ? '?' + query : '') + location.hash);
      }

      // Klick-Delegation im Panel: Checkbox togglet, Reset leert alle Gruppen
      filterPanel.addEventListener('click', e => {
        const reset = e.target.closest('[data-reset]');
        if (reset) {
          Object.values(state).forEach(s => s.clear());
          applyFilters();
          return;
        }
        const ctrl = e.target.closest('[data-value]');
        if (ctrl && ctrl.dataset.group) {
          const g = ctrl.dataset.group;
          const v = ctrl.dataset.value;
          if (state[g].has(v)) state[g].delete(v);
          else state[g].add(v);
          applyFilters();
        }
      });

      // ── Sidebar (Desktop) ↔ Drawer (Mobile) ──
      // matchMedia steuert inert/role, damit das Panel auf dem Desktop als
      // statische, voll bedienbare Sidebar funktioniert (inert nur im Drawer).
      const openBtn  = document.querySelector('[data-drawer-open]');
      const backdrop = document.querySelector('[data-drawer-backdrop]');
      const closeEls = Array.from(document.querySelectorAll('[data-drawer-close]'));
      const mq = window.matchMedia('(max-width: 900px)');

      const openDrawer = () => {
        filterPanel.classList.add('is-open');
        if (backdrop) backdrop.classList.add('is-open');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        filterPanel.removeAttribute('inert');
        filterPanel.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      };
      const closeDrawer = () => {
        filterPanel.classList.remove('is-open');
        if (backdrop) backdrop.classList.remove('is-open');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        filterPanel.setAttribute('inert', '');
        filterPanel.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (openBtn) openBtn.focus();
      };
      // Desktop = statische Sidebar (immer aktiv); Mobile = Drawer (zu, inert)
      const applyMode = () => {
        filterPanel.classList.remove('is-open');
        if (backdrop) backdrop.classList.remove('is-open');
        document.body.style.overflow = '';
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        if (mq.matches) {
          filterPanel.setAttribute('role', 'dialog');
          filterPanel.setAttribute('aria-modal', 'true');
          filterPanel.setAttribute('inert', '');
          filterPanel.setAttribute('aria-hidden', 'true');
        } else {
          filterPanel.removeAttribute('role');
          filterPanel.removeAttribute('aria-modal');
          filterPanel.removeAttribute('inert');
          filterPanel.removeAttribute('aria-hidden');
        }
      };

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      closeEls.forEach(el => el.addEventListener('click', closeDrawer));
      if (backdrop) backdrop.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && filterPanel.classList.contains('is-open')) closeDrawer();
      });
      mq.addEventListener('change', applyMode);

      // Vorauswahl aus der Adresse: ?filter=<handle> (Pillen des Shop-Menüs, oder
      // mehrfach von applyFilters nach dem Sortieren) hakt die passenden, auf dieser
      // Seite vorhandenen Werte an (data-handle in snippets/filter-leiste.liquid).
      // Kein Treffer → alles bleibt sichtbar.
      new URLSearchParams(location.search).getAll('filter').forEach(vorauswahl => {
        const treffer = checks.find(c => c.dataset.handle === vorauswahl && !c.closest('li')?.hidden);
        if (treffer) state[treffer.dataset.group].add(treffer.dataset.value);
      });

      applyMode();
      applyFilters();
    }

    // ── Sortierung (Collection / Suche) ──
    // Lädt mit neuem sort_by und behält den Rest der Adresse (q, type, filter).
    document.querySelectorAll('.sort-select').forEach(select => {
      select.addEventListener('change', () => {
        const url = new URL(location.href);
        url.searchParams.set('sort_by', select.value);
        location.href = url.toString();
      });
    });

    // ── 3D Tilt-Interaktion für Kacheln mit [data-tilt] ──
    document.querySelectorAll('[data-tilt]').forEach(el => {
      let entering = false;

      el.addEventListener('mouseenter', () => {
        entering = true;
        el.style.transition = 'transform 280ms ease-out, box-shadow 150ms ease';
        setTimeout(() => { entering = false; }, 300);
      });

      el.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const dx = (e.clientX - (r.left + r.width  / 2)) / (r.width  / 2);
        const dy = (e.clientY - (r.top  + r.height / 2)) / (r.height / 2);
        if (!entering) el.style.transition = 'transform 80ms ease-out, box-shadow 150ms ease';
        el.style.transform = `perspective(700px) rotateX(${dy * 6}deg) rotateY(${dx * -6}deg) translateZ(6px)`;
      });

      el.addEventListener('mouseleave', () => {
        entering = false;
        el.style.transition = 'transform 0.4s ease, box-shadow 150ms ease';
        el.style.transform = 'perspective(700px) rotateX(0) rotateY(0) translateZ(0)';
      });
    });

    // ── Cart Mengenstepper (nur Warenkorb-SEITE; der Drawer behandelt seine Stepper selbst) ──
    const cartSteppers = document.querySelectorAll('.cart-items .qty-stepper[data-item-key]');
    if (cartSteppers.length) {
      cartSteppers.forEach(stepper => {
        const key = stepper.dataset.itemKey;
        const valEl = stepper.querySelector('.qty-stepper__val');
        stepper.querySelector('.qty-stepper__btn--minus').addEventListener('click', () => {
          const qty = Math.max(0, parseInt(valEl.textContent) - 1);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
          }).then(() => location.reload());
        });
        stepper.querySelector('.qty-stepper__btn--plus').addEventListener('click', () => {
          const qty = parseInt(valEl.textContent) + 1;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
          }).then(() => location.reload());
        });
      });
    }

    // ── Header-Warenkorbzähler aktualisieren ──
    function updateCartCount() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const el = document.querySelector('[data-cart-count]');
          if (!el) return;
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        })
        .catch(() => {});
    }

    // ── Produkt-Detailseite: "In den Warenkorb"-Formular per AJAX (kein Redirect zu /cart) ──
    // Fängt jedes Produkt-Formular ab (deckt produkt-hero-standard + produkt-hero ab).
    // Stilles Hinzufügen: Button-Feedback + Zähler, Drawer bleibt zu (rendert im Hintergrund mit).
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const idField = form.querySelector('[name="id"]');
        if (!idField) return;
        const qtyField = form.querySelector('[name="quantity"]');
        const submitBtn = form.querySelector('[type="submit"]');
        const drawer = document.getElementById('cart-drawer');
        const payload = {
          id: idField.value,
          quantity: parseInt(qtyField && qtyField.value, 10) || 1
        };
        if (drawer) {
          payload.sections = drawer.dataset.sectionId;
          payload.sections_url = window.location.pathname;
        }
        const originalLabel = submitBtn ? submitBtn.innerHTML : '';
        // Kachel-Buttons sind 2rem breit — dort passt nur ein Zeichen.
        const compact = submitBtn ? submitBtn.hasAttribute('data-compact') : false;
        if (submitBtn) submitBtn.disabled = true;
        // Blüten sofort beim Klick: so viele wie Artikel danach im Warenkorb (Zähler + Menge),
        // ohne auf den Shop zu warten (docs/warenkorb-blueten.md)
        if (submitBtn && window.florentiaBlueten) {
          const countEl = document.querySelector('[data-cart-count]');
          const bisher = parseInt(countEl && countEl.textContent, 10) || 0;
          window.florentiaBlueten(submitBtn.getBoundingClientRect(), bisher + payload.quantity, { kraeftig: true });
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).then(r => r.json()).then((data) => {
          if (data && data.status) {
            if (submitBtn) {
              submitBtn.innerHTML = compact ? '✕' : 'Nicht verfügbar';
              setTimeout(() => { submitBtn.innerHTML = originalLabel; submitBtn.disabled = false; }, 1500);
            }
            return;
          }
          if (submitBtn) submitBtn.innerHTML = compact ? '✓' : '✓ Hinzugefügt';
          if (drawer && data && data.sections) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { sections: data.sections } }));
          }
          updateCartCount();
          setTimeout(() => {
            if (submitBtn) { submitBtn.innerHTML = originalLabel; submitBtn.disabled = false; }
          }, 1500);
        }).catch(() => { if (submitBtn) submitBtn.disabled = false; });
      });
    });

    // ── Varianten-Pills: Auswahl je Option, Variante auflösen, Preis/Verfügbarkeit live ──
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const dataEl = form.querySelector('[data-variant-data]');
      if (!dataEl) return;
      let variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      const idField = form.querySelector('[name="id"]');
      const priceEl = document.querySelector('.product-price__amount');
      const compareEl = document.querySelector('.product-price__compare');
      const compareAmountEl = compareEl && compareEl.querySelector('[data-vergleichspreis]');
      const submitBtn = form.querySelector('[type="submit"]');
      const pills = Array.from(form.querySelectorAll('.variant-pills .btn[data-option-position]'));
      const positions = [...new Set(pills.map(p => +p.dataset.optionPosition))].sort((a, b) => a - b);

      const selectedValues = () => positions.map(pos => {
        const sel = pills.find(p => +p.dataset.optionPosition === pos && p.classList.contains('is-selected'));
        return sel ? sel.dataset.value : null;
      });

      const update = () => {
        const vals = selectedValues();
        const variant = variants.find(v => vals.every((val, i) => v.options[i] === val));
        if (variant) {
          if (idField) idField.value = variant.id;
          if (priceEl) priceEl.textContent = variant.priceFormatted;
          if (compareAmountEl) {
            compareAmountEl.textContent = variant.compareFormatted || '';
            compareEl.hidden = !variant.compareFormatted;
          }
          if (submitBtn) {
            submitBtn.disabled = !variant.available;
            submitBtn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
          }
        }
        positions.forEach((pos, idx) => {
          pills.filter(p => +p.dataset.optionPosition === pos).forEach(pill => {
            const trial = vals.slice();
            trial[idx] = pill.dataset.value;
            const ok = variants.some(v => v.available && trial.every((val, i) => val === null || v.options[i] === val));
            pill.disabled = !ok;
          });
        });
      };

      pills.forEach(pill => {
        pill.addEventListener('click', () => {
          if (pill.disabled) return;
          const pos = +pill.dataset.optionPosition;
          pills.filter(p => +p.dataset.optionPosition === pos).forEach(p => {
            const on = p === pill;
            p.classList.toggle('is-selected', on);
            p.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          update();
        });
      });

      update();
    });

  });
})();
